export const currencies = {
    MXN: "MXN",
    USD: "USD"
}